export const HomePageStyles = {
  HomePageContainer: {
    backgroundColor: "#C9DBFF",
  },
};
